const REGULATOR_CENTRAL_PROXY_ORIGIN =
  'https://dev-dsk-konwarpk-2c-cd2eeedf.us-west-2.amazon.com:8443';

export const appIsDevelopment = process.env.NODE_ENV === 'development';
export const appIsTest = process.env.NODE_ENV === 'test';
/**
 * GetApiBaseUrl is responsible to generating the endpoint url for the horizonte controller.
 * We are using horizonte as the middleware for proxying the API calls between Client and the API Gateway.
 * @param apiId Can be rcms or ums. Its defined in API_ID enum
 * @param path actual path to the backend calls
 * @returns the constructed base url for the horizonte middleware.
 */
export const GetApiBaseUrl = () => {
  const host =
    appIsDevelopment || appIsTest
      ? REGULATOR_CENTRAL_PROXY_ORIGIN
      : window.location.origin;
  return `${host}`;
};

//Routes
export const CREATE_CASE_PAGE_ROUTE = '/createCase';
export const ANONYMOUS_CREATE_CASE_PAGE_ROUTE = '/createCaseAnonymous';
export const CASE_DETAILS_PAGE_ROUTE = '/caseDetails/:caseId';
export const ACCESS_DENIED_PAGE_ROUTE = '/accessDenied';
export const LIST_CASE_PAGE_ROUTE = '/listCases';
export const HOME_ROUTE = '/';

//Admin Panel Routes
export const ADMIN_PAGE_ROUTE = '/admin';

export const ADMIN_CHILD_ROUTES = {
  ADD_USER_PAGE: {
    pageUrl: ADMIN_PAGE_ROUTE,
    absoluteUrl: '',
    relativeUrl: '',
  },
  LIST_PAGE: {
    pageUrl: ADMIN_PAGE_ROUTE + '/list',
    absoluteUrl: '/list',
    relativeUrl: 'list',
  },
};

export const FORMATTED_CASE_DETAILS_ROUTE = (caseId: string) =>
  '/caseDetails/' + caseId;

export enum Stage {
  ALPHA = 'Alpha',
  BETA = 'Beta',
  GAMMA = 'Gamma',
  PROD = 'Prod',
}

export enum AMAZON_AUTH_DOMAINS {
  ALPHA = 'development.amazon.com',
  BETA = 'development.amazon.com',
  GAMMA = 'pre-prod.amazon.com',
  PROD = 'www.amazon.com',
}

export const GET_AMAZON_AUTH_URL = (
  amazonDomain: string,
  redirectTo: string,
  language: string,
) =>
  `https://${amazonDomain}/ap/signin?openid.pape.max_auth_age=3600&openid.return_to=${redirectTo}&openid.identity=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.assoc_handle=amzn_labcentral_desktop_us&openid.mode=checkid_setup&language=${language}&openid.claimed_id=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0%2Fidentifier_select&openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0`;

export const GET_AMAZON_AUTH_SIGNOUT_URL = (
  amazonDomain: string,
  redirectTo: string,
  language: string,
) =>
  `https://${amazonDomain}/ap/signin?&openid.return_to=${redirectTo}&openid.assoc_handle=amzn_labcentral_desktop_us&openid.mode=logout&language=${language}&openid.ns=http%3A%2F%2Fspecs.openid.net%2Fauth%2F2.0`;

export const SUSTAINABILITY_URL_PATTERN = 'hrecomplaints';
export const REPORT_CSAM_URL_PATTERN = 'report-csam';
export const ARTICLE_11_DSA_URL_PATTERN = 'article-11-dsa';
export const PAYMENTS_SERVICES_COMPLAINT_PATTERN =
  'payments-services-complaints';
export const SPIM_PATTERN = 'mpa-escalations';

export const SUSTAINABILITY_FAQ_DOWNLOAD_URL = `https://d3fz4qwh4u8rcv.cloudfront.net/documents/hrecomplaints/FAQ.pdf`;
export const PAYMENTS_SERVICES_COMPLAINT_URL = {
  FAQ_DOWNLOAD_URL: `https://d3fz4qwh4u8rcv.cloudfront.net/documents/payment-services-complaint/FAQ.pdf`,
  SELLER_SUPPORT_URL: 'https://sellercentral-europe.amazon.com/cu/contact-us',
};

export const DEPLOYED_STAGE: string = 'Prod';

export const NO_AUTH_STAGE = [Stage.ALPHA, Stage.BETA, Stage.GAMMA];

export const PUBLIC_URI_PREFIX = '/public';

const localeToAmazonMarketplaceDomain = {
  'en-US': 'co.uk',
  'fr-FR': 'fr',
  'de-DE': 'de',
  'es-ES': 'es',
  'it-IT': 'it',
  'pl-PL': 'pl',
  'sv-SE': 'se',
  'nl-NL': 'nl',
  'pt-PT': 'es',
  'en-IE': 'ie',
};
/**
 * CSAM URL
 * @TODO: Replace the default url once we get a confirmation
 */
export const REPORT_ISSUE_TELL_AMAZON_URL = (locale: string) => {
  const marketplaceDomain = localeToAmazonMarketplaceDomain[locale];
  return marketplaceDomain
    ? `https://www.amazon.${marketplaceDomain}/-/en/gp/help/customer/display.html?ref_=hp_gcs_csd_d2_000_2_TLtMJsPGBmJPpN3hvy_7SqzULBKWt&nodeId=TLtMJsPGBmJPpN3hvy&qid=1716914162940&sr=2`
    : 'https://www.amazon.de/-/en/gp/help/customer/display.html?ref_=hp_gcs_csd_d2_000_2_TLtMJsPGBmJPpN3hvy_7SqzULBKWt&nodeId=TLtMJsPGBmJPpN3hvy&qid=1716914162940&sr=2';
};

export const REPORT_ISSUE_AMAZON_ACCOUNT_PAGE = (locale: string) => {
  const marketplaceDomain = localeToAmazonMarketplaceDomain[locale];
  return marketplaceDomain
    ? `https://www.amazon.${marketplaceDomain}/gp/css/homepage.html`
    : 'https://www.amazon.de/gp/css/homepage.html';
};

export const QueryParamKeys = {
  REDIRECT_KEY: 'redirectTo',
} as const;
